<ng-http-loader [spinner]="spinkit.skSpinnerPulse"  [filteredUrlPatterns]="['getActiveDowntimeWindow', 'syncRedis']">
</ng-http-loader>
@if (!loggedIn) {
  <app-prelogin></app-prelogin>
}
<router-outlet></router-outlet>

<p-dialog header="Confirmation" [(visible)]="displayBasic" [autoZIndex]="true" [modal]="true">
  <p>Your session will expire in {{counter}} seconds.</p>
  <br>
    <p>Click on continue to stay in application else you will be logout.</p>
    <br>
    <ng-template #footer>
      <div class="col form-footer">
        <button pButton autofocus type="button" class="ey-button-dark me-2 mt-0" (click)="continue()"
        style="margin-right: 30px;">Continue</button>
        <button pButton type="submit" class="ey-secondary-dark me-2 mt-0" (click)="cancel()"
        style="margin-right: 30px;">Cancel</button>
      </div>
    </ng-template>
    </p-dialog>

    <p-confirmDialog></p-confirmDialog>